<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-work-day :width="22" :height="22" />근무 스케줄을 선택해주세요.
      </v-col>
    </v-row>

    <v-row class="pl-6 ma-0 bt-line condition-wrap">
      <!-- 근무유형  -->
      <v-col cols="12" class="pa-0 pb-1 mt-3 d-flex justify-space-between">
        <span class="label">근무유형</span>
        <span class="date">{{ GET_WORK_ORG_NM }}</span>
      </v-col>
    </v-row>

    <v-row class="ma-0">
      <v-col cols="12" class="py-5 px-6 bt-line borderLine-outer">
        <div class="borderLine-wrap" @click="bottomSelect = !bottomSelect">
          <span class="borderLine-title">근무스케줄</span>
          <v-btn elevation="0" text fab width="24" height="24" class="ml-auto">
            <v-icon size="24" color="#9ca3ab">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <div class="py-3">
          <span>{{ selectedTimeCdNm || `근무스케줄을 선택해주세요.` }}</span>
        </div>
      </v-col>
    </v-row>

    <!-- 비고 선택 목록-->
<!--    <bottom-select-->
<!--      :flag="bottomSelect"-->
<!--      :list="GET_WORK_ORG_TIME_LIST"-->
<!--      :title="selecttitle"-->
<!--      @selectItem="selectTimeCd"-->
<!--    ></bottom-select>-->
    <v-bottom-sheet v-if="bottomSelect" v-model="bottomSelect">
      <bottom-sheet :title="selecttitle" :default="selected" :items="GET_WORK_ORG_TIME_LIST" :codeKey="'timeCd'" :nameKey="'timeNm'" @selectItem="selectTimeCd"></bottom-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import BottomSelect from '@/components/application/form/BottomSelect.vue';
import IconWorkDay from '@/assets/customIcon/IconWorkDay.vue';
import routerNames from '@/const/routerConstants';

import { mapGetters, mapMutations } from 'vuex';
import BottomSheet from "@/components/application/form/BottomSheet.vue";
export default {
  data: () => ({
    bottomSelect: false,
    selecttitle: '근무시간',
    selectedTimeCdNm: '',
    selected : ''
  }),
  computed: {
    ...mapGetters('ELA', [
      'GET_WORK_ORG_NM',
      'GET_WORK_ORG_TIME_LIST',
      'GET_SCHEDULE_TIME_CD',
    ]),
  },
  methods: {
    ...mapMutations('ELA', ['SET_SCHEDULE_TIME_CD', 'SET_SCHEDULE_TIME_NM']),

    selectTimeCd(item) {
      this.selectedTimeCdNm = item.timeNm;
      this.SET_SCHEDULE_TIME_CD(item.timeCd);
      this.SET_SCHEDULE_TIME_NM(item.timeNm);
      this.bottomSelect = !this.bottomSelect;
      this.nextStep();
    },
    nextStep() {
      this.$router.push(routerNames.ExtraOptions);
    },
  },
  components: {
    BottomSheet,
    BottomSelect,
    IconWorkDay,
  },
};
</script>

<style></style>
